module.exports = __webpack_public_path__ + "img/2.b556cc93.png";